<template>
  <section
    class="external-poll-section"
    :style="{
      '--poll-panelBgColor': config.panelBgColor,
      '--poll-outlineColor': config.panelOutlineColor,
      '--poll-questionColor': config.questionColor,
      '--poll-questionBgColor': config.questionBgColor,
      '--poll-optionsColor': config.optionsColor,
      '--poll-optionsBgColor': config.optionsBgColor,
      '--poll-pickedColor': config.pickedColor,
      '--poll-pickedBgColor': config.pickedBgColor,
      '--poll-btnColor': config.btnColor,
      '--poll-btnBgColor': config.btnBgColor,
    }">
    <!-- <h2 class="poll-title">{{title}}</h2> -->
    <div class="question-container">
      <!-- <div class="quiz-question-img-container" >
        <img class="quiz-question-img" :src="currentQuestionComputed.question.image" v-if="currentQuestionComputed.question && currentQuestionComputed.question.image">
      </div> -->
      <div class="question-text" v-html="localizedQuestion"></div>
      <StarsRating
        :options="options"
        :totalStars="options.length"
        :interacted="interacted"
        :globalRating="ratingComputed"
        :isIndicatorActive="true"
        :typeShowResults="typeShowResults"
        :showResults="showResults"
        :starStyle="starStyle"
        @clicked="pollRated"
        v-if="typeObject.ratings && options.length && options.length <= 5" />

      <ScoreBar :options="options" :totalVotes="totalVotes" :interacted="interacted" :showResults="showResults" :typeShowResults="typeShowResults" @clicked="pollRated" v-if="typeObject.ratings && options.length > 5" />
      <draggable class="options-container" v-if="!typeObject.ratings && options.length" v-bind="dragFieldOptions" v-model="options">
        <div
          class="option-item"
          v-for="(option, idx) in options"
          :key="idx"
          v-show="option.fixed"
          @click.prevent="pollRated(idx)"
          :class="{ unpicked: ((picked || picked == 0) && picked != idx) || ((interacted || interacted == 0) && interacted != idx), picked: picked == idx || interacted == idx }">
          <div class="option-text">{{ getLocalizedOption(idx, option) }}</div>
          <div v-show="showResults && typeShowResults" class="option-score">{{ `${option.score || option.score == 0 ? option.score.toFixed(0) + '%' : ''}` }}</div>
        </div>
      </draggable>
    </div>
  </section>
</template>

<script>
import StarsRating from '@/components/external_interactions/StarsRating.vue';
import ScoreBar from '@/components/external_interactions/ScoreBar.vue';
import draggable from 'vuedraggable';

export default {
  name: 'ExternalPoll',
  components: {
    StarsRating,
    ScoreBar,
    draggable,
  },

  props: {
    config: {
      type: Object,
    },
    typeObject: {
      type: Object,
      default: () => ({ ratings: false }),
    },
    answers: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    resultsTitle: {
      type: String,
      default: '',
    },
    typeShowResults: {
      type: Boolean,
      default: false,
    },
    interacted: {
      type: Number,
      default: null,
    },
    localized: {
      default: null,
    },
  },

  data() {
    return {
      poll_id: null,
      showTitle: true,
      showQuestion: true,
      showResults: false,
      currentQuestion: '',
      options: [],
      finished: false,
      picked: null,
      starStyle: {
        fullStarColor: '#ed8a19',
        emptyStarColor: '#737373',
        indicatorColor: '#FFFFFF',
        starWidth: 78,
        starHeight: 78,
      },
      dragFieldOptions: {
        animation: 200,
        disabled: true,
      },
    };
  },

  computed: {
    jsonParsedLocalized() {
      if (!this.localized) return {};

      let parsedLocalized;
      try {
        parsedLocalized = JSON.parse(this.localized);
      } catch (e) {
        console.error('Error parsing localized content:', e);
      }
      return parsedLocalized;
    },

    localizedContent() {
      const currentLocale = this.$i18n.locale || 'pt';
      return this.jsonParsedLocalized[currentLocale] || this.jsonParsedLocalized['pt'] || {};
    },

    localizedQuestion() {
      if (!this.$store.state.template.multilanguagesConfig) return this.currentQuestion;
      return this.localizedContent.question || this.currentQuestion;
    },

    totalVotes() {
      return this.answers.reduce((acc, vote) => acc + vote, 0);
    },

    ratingComputed() {
      return this.totalVotes ? this.answers.reduce((acc, vote, index) => acc + vote * (index + 1), 0) / this.totalVotes : 0;
    },
  },

  methods: {
    getLocalizedOption(idx, option) {
      if (!this.$store.state.template.multilanguagesConfig) return option.title;
      return this.localizedContent.options?.[idx] || option.title;
    },
    hidePoll() {
      this.$emit('hidePoll');
    },
    beginPoll(pollData) {
      this.poll_id = pollData.poll_id;
      this.currentQuestion = pollData.question;

      this.options = [];
      for (let i = 0; i < pollData.options.length; i++) {
        this.options.push({
          title: pollData.options[i].title,
          score: 0,
          fixed: true,
        });
      }
      let marker = `${this.$store.state.user.id}-${pollData.poll_id}`;
      if (this.$store.state.markers.answeredPolls.includes(marker)) {
        this.options.map((opt) => {
          opt.fixed = true;
          return opt;
        });
        // this.currentQuestion = this.currentQuestion + '<br><p style="margin-top:10px;opacity:0.8"> Sua resposta já foi computada. Obrigado!</p>';
        this.showResults = this.typeShowResults;
        this.finished = true;
        if (this.typeShowResults)
          this.options.map((opt) => {
            opt.fixed = true;
            return opt;
          });
      } else {
        this.showResults = false;
        this.finished = false;
      }
    },
    sendAnswer(value) {
      // if (this.finished) return;

      this.finished = true;
      this.$emit('finished', {
        id: this.poll_id,
        answer: value,
      });

      // if (!this.typeShowResults) {
      //   this.options.map((opt, i) => {
      //     if (value != i) opt.fixed = false;
      //     return opt;
      //   });
      // }

      this.picked = value;
      this.showResults = true;
    },
    updatePoll(values, total) {
      // console.log('updatePoll', values, total);
      for (let i = 0; i < values.length; i++) {
        this.options[i].score = (values[i] / total) * 100;
      }
    },
    pollRated(value) {
      console.log('pollRated', this.interacted, value);
      if (this.interacted >= 0 && this.interacted != value) {
        console.log('sendAnswer', this.interacted, value);
        this.sendAnswer(value);
      } else if (isNaN(this.interacted)) {
        console.log('isNaN', this.interacted, value);
        this.sendAnswer(value);
      }
    },
  },

  beforeMount() {
    this.starStyle.fullStarColor = this.config.pickedBgColor;
    this.starStyle.indicatorColor = this.config.optionsColor;
  },
};
</script>

<style scoped lang="scss">
.external-poll-section {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .poll-title {
    position: relative;
    margin: 0px auto 30px;
    padding: 5px 30px;
    width: auto;
    text-transform: uppercase;
    background: var(--live-bgColor);
    color: var(--live-textColor);
    box-shadow: 0 0 20px #000;
    border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
  }

  .question-container {
    position: relative;
    padding: 15px 0;
    width: 100%;
    max-width: 1024px;
    border-radius: var(--input-borderRadius);
    border: 1px solid var(--poll-outlineColor);
    background: var(--poll-panelBgColor);
    overflow: hidden;
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background: var(--poll-panelBgColor);
    }
  }

  .question-text {
    position: relative;
    margin: 0 15px 15px;
    padding: 8px;
    border-radius: var(--input-borderRadius);
    color: var(--poll-questionColor);
    background: var(--poll-questionBgColor);

    filter: brightness(1);

    font-size: 1.2rem;
  }

  .options-container {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0 10px;

    display: flex;
    // flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: column;
  }

  .option-item {
    cursor: pointer;
    position: relative;
    min-height: 40px;
    margin: 6px;
    padding: 0 0 0 16px;

    background: var(--poll-optionsBgColor);
    color: var(--poll-optionsColor);
    border-radius: var(--input-borderRadius);

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: stretch;

    &:active:not(.picked, .unpicked) {
      transform: scale(0.98);
      opacity: 0.8;
    }
    &:disabled {
      opacity: 0.3;
      cursor: auto;
    }
    &.unpicked {
      color: var(--poll-optionsColor);
      background: var(--poll-optionsBgColor);
    }
    &.picked {
      color: var(--poll-pickedColor);
      background: var(--poll-pickedBgColor);
    }

    .option-image-text {
      position: relative;
      flex-grow: 1;

      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      align-items: center;
    }
    .option-text {
      position: relative;
      padding: 0 10px 0 0;
      flex: 1;

      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: normal;

      display: flex;
      align-items: center;
    }
    .option-image {
      position: relative;
      padding: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        max-height: 72px;
        object-fit: cover;
      }
    }
    .option-score {
      opacity: 0.8;
      font-size: 0.8rem;
      // align-self: center;
      font-size: 1.2rem;
      margin: 0 6px 0 auto;

      display: flex;
      align-items: center;
    }
  }
}
</style>
